import React, { forwardRef } from 'react';
// import CompareSectionMobile from '../compareSectionMobile/CompareSectionMobile';
import { getColorClass } from '../../../../../utils/utils';
// import InfoPopup from '../../../../molecules/shared/infoPopup/InfoPopup';
// import StarRating from '../../../../molecules/shared/starRating/StarRating';
import { Typography } from '../../../../atoms/typography/Typography';

const CompareSectionReviews = forwardRef(
  ({ title, subtitle, items, systems, renderValue, first, t }, ref) => {
    const props = { title, subtitle, items, systems, renderValue, first };

    return (
      <div className="flex flex-col" ref={ref}>
        {/* Mobile Section */}
        {/* <CompareSectionMobile {...props} /> */}
        {/* Desktop Section */}
        <div className="flex flex-row w-full justify-between gap-1 sm:gap-5">
          <div className="hidden lg:flex flex-1 flex-col" />
          {systems.map((system, i) => (
            <div
              key={i}
              className="flex flex-1 flex-col basis-0 px-1 sm:px-5 mb-1 justify-end gap-1 divide-y divide-primary-200"
            >
              <Typography
                fontVariant="md"
                textAlign="left"
                className="line-clamp-1 break-all"
              >
                {t('compare.basedOnNumberReviews', {
                  number: system.reviewsCount,
                })}
              </Typography>
            </div>
          ))}
        </div>
        <div className="flex flex-row w-full justify-between gap-1 sm:gap-5">
          <div className="hidden lg:flex flex-1 flex-col">
            <div className="flex flex-1 flex-col gap-1" />
          </div>

          {systems.map((system, i) => (
            <div
              key={i}
              className={`flex flex-1 flex-col basis-0 p-1 sm:p-5 mb-2 justify-end gap-1 divide-y divide-primary-200 rounded-xl shadow-md ${getColorClass(
                i
              )}`}
            >
              {system.averageRatings?.map((ratingItem) => (
                <div
                  key={ratingItem.title}
                  className="flex flex-col lg:flex-row items-center h-16 place-content-end"
                >
                  {renderValue(ratingItem)}
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    );
  }
);

export default CompareSectionReviews;
